import React, { useEffect, useMemo, useState } from "react"
import { Modal } from "antd"
import { DoLogout } from "../../../../../services/plat/UserService"
import { actionCreator } from "../../../store"
import store from "../../../../../store"
import { clearStorage, readLoginPath, readQlAlert, readUserCode, writeLoginPath, writeQlAlert, writeUserCode } from "../../../../../utils/storage"
import { publishLogout } from "../../../../../utils/ps"
import { isTenant067 } from "../../../../../utils/tenant-assoc"

const QlAlert = ()=> {

  const [visible, setVisible] = useState(false)

  const handleCancel = async()=> {
    await DoLogout({})

    const action = actionCreator.PageStateAction({});
    store.dispatch(action)
    
    const userCode = readUserCode();
    const loginPath = readLoginPath();

    clearStorage()
    writeLoginPath(loginPath)
    writeUserCode(userCode);
    
    publishLogout()
  }

  const handleConfirm = ()=> {
    writeQlAlert()
    setVisible(false)
  }

  useEffect(()=> {
    if (isTenant067()) {
      setVisible(true)
    }
  }, [])

  if (readQlAlert()) {
    return null
  }

  return (
    <Modal
      title="提示"  
      cancelText='取消'
      okText='确定'
      open={visible}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleConfirm}
    >
      <div className={"login_code"}>当前录入数据的时间已超出临床协议约定日期，若产生任何法律风险，由研究中心自行承担。</div>    
  </Modal>
  )
}

export default QlAlert